import { Navigate, useRoutes } from 'react-router-dom';
// auth
import AuthGuard from '../auth/AuthGuard';
import IntranetGuestGuard from '../auth/IntranetGuard';

// layouts
import CompactLayout from '../layouts/compact';
import DashboardLayout from '../layouts/dashboard';
// config
import { PATH_AFTER_INTRANET_LOGIN } from '../config-global';
//
import {
  IntranetLoginPage,
  Page404,
  ComingSoonPage,
  UserProfilePage,
  UserListPage,
  UserCreatePage,
  UserEditPage,
  IntranetDashboardPage,
  IntranetRequestListPage,
  IntranetRequestEditPage,
  IntranetRequestNewPage,
  IntranetRequestViewPage,
  IntranetUserListPage,
  IntranetUserCreatePage,
  IntranetUserEditPage,
  IntranetMediatorListPage,
  IntranetMediatorNewPage,
  IntranetMediatorEditPage,
  IntranetMediatorViewPage,
  IntranetUserAccountPage,
  FatturazionePage,
  InvoiceCreate,
  InvoiceListPage,
  InvoiceDetailPage,
  LanguageListPage,
  TranslationOrdersPage,
} from './elements';
import RoleBasedGuard from '../auth/RoleBasedGuard';

// ----------------------------------------------------------------------

export default function Router() {
  return useRoutes([
    {
      path: '/',
      element: (
        <IntranetGuestGuard>
          <IntranetLoginPage />
        </IntranetGuestGuard>
      ),
    },

    {
      path: 'intranet',
      element: (
        <AuthGuard type="intranet">
          <DashboardLayout />
        </AuthGuard>
      ),
      children: [
        { element: <Navigate to={PATH_AFTER_INTRANET_LOGIN} replace />, index: true },
        {
          path: 'app',
          element: (
            <RoleBasedGuard hasContent roles={['admin', 'user']}>
              <IntranetDashboardPage />
            </RoleBasedGuard>
          ),
        },

        {
          path: 'utente',
          children: [
            {
              path: 'lista',
              element: (
                <RoleBasedGuard hasContent roles={['admin']}>
                  <IntranetUserListPage />
                </RoleBasedGuard>
              ),
            },
            {
              path: 'nuova',
              element: (
                <RoleBasedGuard hasContent roles={['admin']}>
                  <IntranetUserCreatePage />
                </RoleBasedGuard>
              ),
            },
            {
              path: ':id/modificare',
              element: (
                <RoleBasedGuard hasContent roles={['admin']}>
                  <IntranetUserEditPage />
                </RoleBasedGuard>
              ),
            },
            {
              path: ':id',
              element: <UserProfilePage />,
            },
          ],
        },
        {
          path: 'utente/cliente',
          children: [
            {
              path: 'lista',
              element: (
                <RoleBasedGuard roles={['admin']} hasContent>
                  <UserListPage />
                </RoleBasedGuard>
              ),
            },
            {
              path: 'new',
              element: (
                <RoleBasedGuard roles={['admin']} hasContent>
                  <UserCreatePage />
                </RoleBasedGuard>
              ),
            },
            {
              path: ':id/modificare',
              element: (
                <RoleBasedGuard roles={['admin']} hasContent>
                  <UserEditPage />
                </RoleBasedGuard>
              ),
            },
            {
              path: ':id',
              element: (
                <RoleBasedGuard roles={['admin']} hasContent>
                  <UserProfilePage />
                </RoleBasedGuard>
              ),
            },
          ],
        },
        {
          path: 'richieste',
          children: [
            {
              path: 'lista',
              element: (
                <RoleBasedGuard roles={['admin']} hasContent>
                  <IntranetRequestListPage />
                </RoleBasedGuard>
              ),
            },
            {
              path: 'nuova',
              element: (
                <RoleBasedGuard roles={['admin']} hasContent>
                  <IntranetRequestNewPage />
                </RoleBasedGuard>
              ),
            },
            {
              path: ':id/modificare',
              element: (
                <RoleBasedGuard roles={['admin']} hasContent>
                  <IntranetRequestEditPage />
                </RoleBasedGuard>
              ),
            },
            {
              path: ':id',
              element: (
                <RoleBasedGuard roles={['admin']} hasContent>
                  <IntranetRequestViewPage />
                </RoleBasedGuard>
              ),
            },
          ],
        },
        {
          path: 'fatturazione',
          element: (
            <RoleBasedGuard roles={['admin', 'user']} hasContent>
              <FatturazionePage />
            </RoleBasedGuard>
          ),
        },
        {
          path: 'utente/mediatrice',
          children: [
            {
              path: 'lista',
              element: (
                <RoleBasedGuard hasContent roles={['admin']}>
                  <IntranetMediatorListPage />
                </RoleBasedGuard>
              ),
            },
            {
              path: 'nuova',
              element: (
                <RoleBasedGuard hasContent roles={['admin']}>
                  <IntranetMediatorNewPage />
                </RoleBasedGuard>
              ),
            },
            {
              path: ':id/modificare',
              element: (
                <RoleBasedGuard hasContent roles={['admin']}>
                  <IntranetMediatorEditPage />
                </RoleBasedGuard>
              ),
            },
            {
              path: ':id',
              element: (
                <RoleBasedGuard hasContent roles={['admin']}>
                  <IntranetMediatorViewPage />
                </RoleBasedGuard>
              ),
            },
          ],
        },
        {
          path: 'profilo',
          element: (
            <RoleBasedGuard roles={['admin', 'user']} hasContent>
              <IntranetUserAccountPage />{' '}
            </RoleBasedGuard>
          ),
        },
        {
          path: 'invoice',
          element: (
            <RoleBasedGuard roles={['admin', 'user']} hasContent>
              <InvoiceListPage />{' '}
            </RoleBasedGuard>
          ),
        },
        {
          path: 'invoice/:id',
          element: (
            <RoleBasedGuard roles={['admin', 'user']} hasContent>
              <InvoiceDetailPage />{' '}
            </RoleBasedGuard>
          ),
        },
        {
          path: 'invoice/new',
          element: (
            <RoleBasedGuard roles={['admin', 'user']} hasContent>
              <InvoiceCreate />{' '}
            </RoleBasedGuard>
          ),
        },
        {
          path: 'lingue',
          element: (
            <RoleBasedGuard roles={['admin', 'user']} hasContent>
              <LanguageListPage />{' '}
            </RoleBasedGuard>
          ),
        },
        {
          path: 'traduzioni',
          element: (
            <RoleBasedGuard roles={['admin', 'user']} hasContent>
              <TranslationOrdersPage />
            </RoleBasedGuard>
          ),
        },
      ],
    },

    {
      element: <CompactLayout />,
      children: [
        // { element: <HomePage />, index: true },
        { path: 'coming-soon', element: <ComingSoonPage /> },
        { path: '404', element: <Page404 /> },
      ],
    },
    { path: '*', element: <Navigate to="/404" replace /> },
  ]);
}
